/* HYV — B2B price list gate (sections/hyv-b2b-price-list.liquid)
   Soft gate by design: the lead matters, but a network failure must never
   stand between a real buyer and the prices. Failed posts queue in
   localStorage and retry on the next visit. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hyv-b2b]');
  if (!root) return;

  var ACCESS_KEY = 'hyv_b2b_access';
  var QUEUE_KEY = 'hyv_b2b_lead_queue';
  var gate = root.querySelector('[data-hyv-b2b-gate]');
  var form = root.querySelector('[data-hyv-b2b-form]');
  var endpoint = root.getAttribute('data-endpoint') || '';
  var accessDays = parseInt(root.getAttribute('data-access-days'), 10) || 30;

  function readAccess() {
    try {
      var a = JSON.parse(localStorage.getItem(ACCESS_KEY));
      if (a && a.timestamp && Date.now() - a.timestamp < accessDays * 864e5) return a;
    } catch (e) { /* storage unavailable → gate shows, which is the safe default */ }
    return null;
  }

  // The scroll lock is kept on purpose even though this file's own CSS no
  // longer defines `body.hyv-b2b-lock` — the gate now covers the rate grid
  // rather than the page, so freezing the scroll would trap a reader in the
  // one place they had no reason to be. The class is therefore inert here.
  //
  // It stays because this script also has to run against the LIVE theme,
  // whose stylesheet still carries the rule and whose gate is still a
  // full-screen modal. Toggling a class nothing styles costs nothing; landing
  // a lead fix on live at the price of a scrolling backdrop does not.
  function unlock() {
    root.classList.remove('hyv-b2b--gated');
    document.body.classList.remove('hyv-b2b-lock');
    if (gate) gate.hidden = true;
  }

  function lock() {
    root.classList.add('hyv-b2b--gated');
    document.body.classList.add('hyv-b2b-lock');
    if (gate) gate.hidden = false;
  }

  function postLead(payload) {
    if (!endpoint) return Promise.reject(new Error('no endpoint'));
    // text/plain keeps this a CORS "simple request" — no preflight. Google
    // Apps Script cannot answer an OPTIONS preflight at all, and the Netlify
    // function parses the body regardless of the header, so one code path
    // serves both destinations.
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r;
    });
  }

  function queueLead(payload) {
    try {
      var q = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
      q.push(payload);
      localStorage.setItem(QUEUE_KEY, JSON.stringify(q.slice(-5)));
    } catch (e) { /* nothing else to do — the buyer still gets the page */ }
  }

  function retryQueue() {
    var q;
    try { q = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch (e) { return; }
    if (!q.length || !endpoint) return;
    postLead(q[0]).then(function () {
      q.shift();
      localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
      if (q.length) retryQueue();
    }).catch(function () { /* still down — try again next visit */ });
  }

  if (readAccess()) { unlock(); } else { lock(); }
  retryQueue();

  /**
   * An Indian mobile, however it was typed: +91 98765 43210, 091-98765-43210,
   * (+91) 9876543210. Returns the bare 10 digits, or '' if it isn't one.
   * Rejecting these outright was the original bug — most people type the +91.
   */
  function normalisePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length > 10 && d.indexOf('91') === 0) d = d.slice(2);   // +91 / 91
    while (d.length > 10 && d.charAt(0) === '0') d = d.slice(1);  // trunk 0
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return /^[6-9]\d{9}$/.test(d) ? d : '';
  }

  // Clear a field's error as soon as the buyer starts fixing it.
  Array.prototype.forEach.call(form ? form.querySelectorAll('[name]') : [], function (el) {
    el.addEventListener('input', function () {
      var fl = el.closest('.hyv-b2b__gfield');
      if (fl) fl.classList.remove('hyv-b2b__gfield--err');
      var s = form.querySelector('[data-hyv-b2b-summary]');
      if (s) s.hidden = true;
    });
  });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = function (n) { return form.querySelector('[name=' + n + ']'); };
    var phoneClean = '';
    try {
      var bad = false, firstBad = null;
      var mark = function (n, isBad) {
        var field = f(n).closest('.hyv-b2b__gfield');
        if (field) field.classList.toggle('hyv-b2b__gfield--err', isBad);
        if (isBad && !firstBad) firstBad = field || f(n);
        bad = bad || isBad;
      };
      mark('name', f('name').value.trim().length < 2);
      mark('company', f('company').value.trim().length < 2);
      mark('email', !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f('email').value.trim()));
      phoneClean = normalisePhone(f('phone').value);
      mark('phone', !phoneClean);
      mark('business_type', !f('business_type').value);
      if (bad) {
        // Say so out loud: the per-field message can sit below the fold in the
        // modal, which reads as "the button does nothing".
        var summary = form.querySelector('[data-hyv-b2b-summary]');
        if (summary) { summary.hidden = false; }
        if (firstBad && firstBad.scrollIntoView) firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
    } catch (err) {
      // Fail open: a scripting fault must never stand between a buyer and the
      // prices. Log it, let them through, and post what we have.
      if (window.console) console.error('[hyv-b2b] gate validation error', err);
    }

    // Honeypot: bots fill hidden fields; humans never see this one. A filled
    // honeypot gets the page (no tell) but the lead is silently dropped.
    var isBot = f('website') && f('website').value !== '';

    var payload = {
      // REQUIRED. The Apps Script's doPost dispatches on this key, and its
      // default branch is the CAREERS handler — so a lead posted without it
      // was silently filed as a job application, with company landing in
      // "Current company" and business type, GSTIN, city and quantity dropped
      // on the floor. It also never emailed, because that handler only sends
      // when the payload carries sendEmail. Losing this key loses the lead.
      action: 'b2b_lead',
      name: f('name').value.trim(),
      company: f('company').value.trim(),
      email: f('email').value.trim(),
      phone: phoneClean || String(f('phone').value || '').replace(/\D/g, ''),
      gstin: f('gstin').value.trim(),
      quantity: f('quantity') ? f('quantity').value.trim() : '',
      business_type: f('business_type').value,
      city: f('city').value.trim(),
      page: location.href,
      submitted_at: new Date().toISOString()
    };

    // Open the page NOW. Waiting on the round-trip left the button reading
    // "Opening…" while the storefront's app scripts hogged the main thread —
    // which reads as a hang. Delivery is a background concern; access is not.
    try {
      localStorage.setItem(ACCESS_KEY, JSON.stringify({ timestamp: Date.now(), email: payload.email }));
    } catch (e) { /* no storage → they'll see the gate next visit; fine */ }
    unlock();

    var btn = form.querySelector('.hyv-b2b__gsubmit');
    if (btn) { btn.disabled = false; btn.textContent = 'View the rates →'; }

    if (isBot) return;
    postLead(payload).catch(function () {
      // Queued and retried on the next visit; the buyer never sees this.
      queueLead(payload);
    });
  });

  var printBtn = root.querySelector('[data-hyv-b2b-print]');
  if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
})();
